import { a as s, j as r } from "../../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { IonChip as i } from "@ionic/react";
import { I as c } from "../../../../../Icon-D8QUNSZR.js";
import "../../../../../FeatureFlagProvider-CQds873Z.js";
import "react";
import { translate as o } from "../../../../string-table.js";
import "../../../../../react-paginate-Lh5zQzpz.js";
import "../../../LoadingInterstitial/LoadingInterstitial.js";
import "../../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
function F(l) {
  const {
    chipData: n
  } = l, {
    isDistrictFavorited: p,
    languages: a,
    hasSpedExperience: d,
    daysWorked: e,
    isReferenceVerified: m
  } = n;
  return /* @__PURE__ */ s("div", {
    css: {
      display: "flex",
      flexWrap: "wrap",
      gap: "var(--spacing-sm)",
      width: "100%",
      marginTop: "var(--spacing-lg)"
    },
    children: [m && /* @__PURE__ */ s(i, {
      color: "success",
      css: {
        display: "flex",
        gap: "var(--spacing-sm)"
      },
      children: [/* @__PURE__ */ r(c, {
        name: "Shield",
        color: "var(--swing-green500)"
      }), /* @__PURE__ */ r("span", {
        css: {
          color: "black"
        },
        children: o("SUB_PROFILE_REFERENCE_VERIFIED")
      })]
    }), p && /* @__PURE__ */ s(i, {
      color: "danger",
      css: {
        display: "flex",
        gap: "var(--spacing-sm)"
      },
      children: [/* @__PURE__ */ r(c, {
        name: "Favorite Filled",
        color: "var(--swing-pink)"
      }), /* @__PURE__ */ r("span", {
        css: {
          color: "black"
        },
        children: o("SUB_PROFILE_DISTRICT_FAVORITE")
      })]
    }), a && (a == null ? void 0 : a.length) > 0 && /* @__PURE__ */ s(i, {
      color: "primary",
      css: {
        display: "flex",
        gap: "var(--spacing-sm)"
      },
      children: [/* @__PURE__ */ r(c, {
        name: "Website",
        color: "var(--swing-teal500)"
      }), /* @__PURE__ */ r("span", {
        css: {
          color: "black"
        },
        children: a.join(", ")
      })]
    }), d && // Intentionally left without a gap, the apple svg is not perfectly square.
    /* @__PURE__ */ s(i, {
      color: "warning",
      children: [/* @__PURE__ */ r(c, {
        name: "Apple",
        color: "var(--swing-yellow600)"
      }), /* @__PURE__ */ r("span", {
        css: {
          color: "black"
        },
        children: o("SUB_PROFILE_SPED_EXP")
      })]
    }), e && e < 5 && /* @__PURE__ */ s(i, {
      color: "success",
      css: {
        display: "flex",
        gap: "var(--spacing-sm)"
      },
      children: [/* @__PURE__ */ r(c, {
        name: "Hourglass",
        color: "var(--swing-green500)"
      }), /* @__PURE__ */ r("span", {
        css: {
          color: "black"
        },
        children: o("SUB_PROFILE_NEW")
      })]
    })]
  });
}
export {
  F as ProfileChips
};
